<template>
  <div>
    <b-button>
        <i class="fas fa-edit" style="color:#0090CD" @click="openEditCollection"></i>
    </b-button>

    <!-- Modal for view groups on a central unit -->
    <groups-central-unit :cu="cuGroups" :readonlyMode="true" v-model="modalGroupsCuVisible" @hide="resetGroupsCuModal"/>  

    <!-- Crea nuova collection Modal-->
    <b-modal
      ref="modal"
      size="lg"
      :id="'modal-edit-collection'+this._uid"
      :saveSubmit="saveSubmit"
      :title="$t('collection.edit_modal_title')"
      :ok-title="$t('user_modal.button_save')"
      :cancel-title="$t('user_modal.button_cancel')"
      @ok="handleOk"
    >
      <b-row>
      <b-col cols="9">
        
        <!--input name of collection -->
        <b-form-group class="ml-2">
          <label class="typo-label">{{$t("collection.label_collection_name")}}</label>
          <b-form-input
            v-model="collectionName"
            type="text"
            :state="validation_collectionName"
          ></b-form-input>
          <b-form-invalid-feedback
            :state="validation_collectionName"
          >{{$t("signup.validation_null")}}</b-form-invalid-feedback>
         </b-form-group>

        <!-- select emergenza oppure illuminazione --> 
        <b-row class="px-3 py-2 mt-2">
          <b-col cols="12">
            <input type="radio" id="lighting" value="lighting" v-model="illum_type">
            <label class="typo-black ml-2" for="illuminazione">{{$t("navbar_dispositivi.lighting")}}</label>
          </b-col> 
          <b-col cols="12">
            <input type="radio" id="emergency" value="emergency" v-model="illum_type">
            <label class="typo-black ml-2" for="illuminazione">{{$t("navbar_dispositivi.emergency")}}</label>
          </b-col> 
        </b-row>

          <!-- label cu group selection-->
          <b-row class="px-3 py-2 mt-2">
           <b-col cols="4">
                <label class="typo-label">{{$t("collection.label_select_cu")}}</label>
            </b-col>
            <b-col cols="3">
                <label class="typo-label">{{$t("collection.label_select_group")}}</label>
            </b-col>
          </b-row>

          <div v-for="(item,pos) in this.itemsCollection" :key="pos" class="px-3 mb-3">
              <b-row>
                <!-- select central unit -->
                <b-col cols="4">
                <b-form-select v-model="item.cu" :options="cu_options" @change="onChangeCent($event+'_'+pos)"  :state="validation_collectionCu"></b-form-select>
                <b-form-invalid-feedback :state="validation_collectionCu">{{$t("signup.validation_null")}}</b-form-invalid-feedback>
              </b-col>
  
                <!-- select group -->
                <b-col cols="3">
                  <b-form-select v-model="item.group" :options="group_options[pos]" :state="validation_collectionGroup"></b-form-select>
                  <b-form-invalid-feedback :state="validation_collectionGroup">{{$t("signup.validation_null")}}</b-form-invalid-feedback>
                </b-col>

                <!-- modal group -->
                <b-col cols="3">
                  <b-button class="typo-butt-add but-add" @click="showGroups(item.cu)">
                    <!-- <i class="fas fa fa-1x fa-plus mr-2"></i> -->
                    {{$t("collection.button_view_group")}}
                  </b-button>
                </b-col>

                <!-- plus button -->
                <b-col cols="1">   
                  <b-button style="color: #0090CD" @click="addInput()"><i class="fas fa fa-1x fa-plus no-border"></i></b-button>
                </b-col>        
      
                <!-- remove button -->
                <b-col cols="1">   
                    <b-button v-if="pos>0" @click="function(){itemsCollection.splice(pos)}"><i class="fa fa-times pt-1"></i></b-button>
                </b-col>  
    
              </b-row>     
          </div> 
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import GroupsCentralUnit from '@/components/GroupsCentralUnit'


export default {
  name: "EditCollection",
  components:{
    GroupsCentralUnit
  },
  data() {
    return {
     collectionName: "",
     cuGroups: null,
     modalGroupsCuVisible:false,
     saveSubmit: "false",
     illum_type: "lighting",
     itemsCollection:[
        {
          cu: '',
          group: ''
        }
      ],
     plantId:"",
     cu_options:[],
     group_options:[]
    };
  },
   props: {
    collection:null,
  },
  computed: {
    validation_collectionName() {
      if (this.saveSubmit == true) return this.collectionName.length > 0;
    },
    validation_collectionCu() {
      if (this.saveSubmit == true) return this.itemsCollection[0].cu != "" ;
    },
    validation_collectionGroup() {
      if (this.saveSubmit == true) return  this.itemsCollection[0].group != "";
    },
    cuIdList() 
    {
      console.log("Unit details", this.$store.state.plantUnits);
      var cuList=[];
      for(var i=0;i<this.$store.state.plantUnits.length;i++)
      {
        //esclusione delle centrali cablecom
        if (this.$store.state.plantUnits[i].cu_type != "cablecom")
          cuList.push(this.$store.state.plantUnits[i].cu_type+"_"+this.$store.state.plantUnits[i].cu_id);
      }
      return cuList;
    }
  },
  methods: {
    showGroups(cu)
    {
      var cent_sel=[];
      cent_sel=cu.split("_");

      var plant = this.$store.state.plantUnits;
      var curr = plant.filter((x) => x.cu_id == cent_sel[1]);
      
      this.cuGroups = curr[0];
      this.modalGroupsCuVisible = true;
      console.log("Open modal groups on Cu", this.cuGroups);
    },
    resetGroupsCuModal() {
      this.cuGroups = null;
    },

    openEditCollection(bvModalEvt) {
      console.log("Edit collection: ",this.collection);

      this.cu_options=this.cuIdList;

      this.itemsCollection = this.collection.collectionItems;
      for(var i=0;i<this.itemsCollection.length;i++)
      {
        this.onChangeCent(this.itemsCollection[i].cu);
      }

      this.illum_type = this.collection.collectionType;
      this.collectionName = this.collection.collectionName;
      console.log("show edit modal " + this._uid);
      this.$bvModal.show('modal-edit-collection'+this._uid);
      
    },

    onChangeCent(cent_selected) {
      console.log("Cent selected: ", cent_selected);
      var cent_sel=[];
      cent_sel=cent_selected.split("_");
      console.log("Cent selected: ", cent_sel.toString());

      var groupList=[];
      //cerco array di gruppi per ogni lampada nella centrale selezionata
      for(var i=0;i<this.$store.state.plantUnits.length;i++)
      {
        if(this.$store.state.plantUnits[i].cu_type == cent_sel[0] && this.$store.state.plantUnits[i].cu_id == cent_sel[1])
        {
          for(var j=0;j<this.$store.state.plantUnits[i].lamps.length;j++)
          {
            //creo un unico array concatenando i gruppi per ogni lampada
            groupList=groupList.concat(this.$store.state.plantUnits[i].lamps[j].groups);
          }
        }
      }
      //tolgo i valori duplicati nell'array complessivo di tutti i gruppi per la centrale
      groupList = [...new Set(groupList)];
      console.log("groupList: ",groupList);
      //assegno l'elenco dei gruppi al b-select di selezione dei gruppi per centrale
      if(this.group_options[cent_sel[2]])
        this.group_options[cent_sel[2]]=groupList;
       else
        this.group_options.push(groupList);
      
      this.$forceUpdate();
      console.log("option_group",this.group_options.toString());

    },
    clearInput()
        {
         this.itemsCollection=[
                {
                  cu: '',
                  group: ''
                }
                ];
         this.group_options=[];     
         this.illum_type="lighting";
        }, 
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveSubmit = true;
      // Trigger submit handler
      this.updateCollection();
    },
    addInput()
      {
        var newItem={ cu: '', group: ''};
        this.itemsCollection.push(newItem);   
      },
    updateCollection() {     
      if (!this.validation_collectionName || !this.validation_collectionCu || !this.validation_collectionGroup) return; 
      
      let self = this;
      this.$nextTick(() => {
        console.log("hide edit modal " + self._uid);
        self.$bvModal.hide('modal-edit-collection'+self._uid);

        self.$store.dispatch("dbUpdateCollection", {
            collectionId: self.collection.collectionId,
            plantId: self.$store.state.currentPlant.id,
            collectionName: self.collectionName,
            collectionType: self.illum_type,
            collectionItems:self.itemsCollection
          });

      });

      
    }
  }
};
</script>
